import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import '@/components/vant.js'
import '@/skeleton.js'
// TODO:使用有赞自定义icon 替换
import '@/icons'
import Vconsole from 'vconsole'

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import 'swiper/swiper.less'

import { IOS, Android } from './JsBrage'
Vue.prototype.$IOS = IOS
Vue.prototype.$Android = Android

import '@/assets/style/common.less'
Vue.config.productionTip = false

// const vConsole = new Vconsole()
// Vue.use(vConsole)

// if (process.env.VUE_APP_BASE_API.indexOf('open-apis.ponhu.cn') == -1) {
//   const vConsole = new Vconsole()
//   Vue.use(vConsole)
// }
// 路由钩子
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

new Vue({
  router,
  store,
  // data () {
  //   return {
  //     isHasHeader: false
  //   }
  // },
  render: h => h(App)
}).$mount('#app')
